import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';
import { queryKeys } from '../lib/queryClient';
import { snakeToCamel, camelToSnake } from '../lib/utils';
import { logAction } from '../lib/actionLogger';

const mapFromDb = (r) => snakeToCamel(r);
const mapToDb = (o) => camelToSnake(o);

// Server-scoped: crew see only their own rows, admins (payroll:full) see all.
export function useCrewEarnings() {
  return useQuery({
    queryKey: queryKeys.crewEarnings.all,
    queryFn: async () => (await api.get('/crew-earnings')).map(mapFromDb),
  });
}

export function useCreateCrewEarning() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (row) => mapFromDb(await api.post('/crew-earnings', mapToDb(row))),
    onSuccess: (data) => {
      qc.invalidateQueries({ queryKey: queryKeys.crewEarnings.all });
      logAction({ action: 'Create Crew Earning', details: { person: data.person, amount: data.amount, item: data.item } });
    },
  });
}

export function useUpdateCrewEarning() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...updates }) => mapFromDb(await api.put(`/crew-earnings/${id}`, mapToDb(updates))),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.crewEarnings.all }),
  });
}

export function useDeleteCrewEarning() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id) => { await api.del(`/crew-earnings/${id}`); },
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.crewEarnings.all }),
  });
}
